import type { DS } from 'ember-data';
import { tracked } from '@glimmer/tracking';
import BaseController from 'uplisting-frontend/pods/base/controller';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class SidebarBookingsMessagesController extends BaseController {
  queryParams = [
    {
      replyId: 'reply',
    },
  ];

  @tracked replyId?: string;

  @tracked booking!: ModelRegistry['booking'];
  @tracked reply?: ModelRegistry['contextual-reply'];
  @tracked messagingChannels!: DS.PromiseArray<
    ModelRegistry['messaging-channel']
  >;
}
